import { POSTWithToken, PUTWithToken } from "./base-service";
import { getCurrentUser as fetchCurrentUserMe } from "./current-user";

const API_URL = "/api/telegram/v1";

export function pickTelegramFieldsFromUser(user) {
  if (!user) {
    return {
      telegramChatId: null,
      telegramUsername: null,
      telegramNotificationsEnabled: false,
    };
  }
  return {
    telegramChatId: user.telegramChatId ?? null,
    telegramUsername: user.telegramUsername ?? null,
    telegramNotificationsEnabled: Boolean(user.telegramNotificationsEnabled),
  };
}

export function fetchTelegramLinkStatus(machineId) {
  return fetchCurrentUserMe(machineId).then((response) =>
    pickTelegramFieldsFromUser(response?.user)
  );
}

export function generateTelegramBindCode() {
  return POSTWithToken(`${API_URL}/bind-code`);
}

export function updateTelegramSettings(telegramNotificationsEnabled) {
  const url = `${API_URL}/settings?telegramNotificationsEnabled=${telegramNotificationsEnabled}`;
  return PUTWithToken(url);
}

export function unbindTelegram() {
  return POSTWithToken(`${API_URL}/unbind`);
}
